import React from 'react';
import { SpeakerListItem } from './speaker-list-item';
import { DragDropList } from '../../../../../../../global/drag-drop-list/drag-drop-list';
import { ISyncSpeakersListItem } from '../sync-speakers.viewmodel';
import './speaker-list.scss';

interface IProps {
    enabledSpeakers: ISyncSpeakersListItem[];
    disabledSpeakers: ISyncSpeakersListItem[];
    setSpeakers: (speakers: ISyncSpeakersListItem[]) => void;
    enableSpeaker: (speaker: ISyncSpeakersListItem) => void;
    disableSpeaker: (speaker: ISyncSpeakersListItem) => void;
    toggleBio: (speaker: ISyncSpeakersListItem) => void;
}

const SpeakerList: React.FC<IProps> = ({ enabledSpeakers, disabledSpeakers, setSpeakers, enableSpeaker, disableSpeaker, toggleBio }) => {
    return (
        <div className='speaker-list'>
            <DragDropList
                numbered={true}
                data={enabledSpeakers}
                renderItem={props => (
                    <SpeakerListItem
                        {...props}
                        enabled={true}
                        toggleSpeaker={disableSpeaker.bind(this, props)}
                        toggleBio={toggleBio.bind(this, props)}
                    />
                )}
                onDragEnd={setSpeakers}
            />
            <div className='disabled-speakers-list'>
                {disabledSpeakers.map((item, index) => (
                    <SpeakerListItem
                        {...item}
                        key={index}
                        enabled={false}
                        toggleSpeaker={enableSpeaker.bind(this, item)}
                    />
                ))}
            </div>
        </div>
    );
};

export { SpeakerList };
